import React from 'react';

const Icon = props => {
    const {
        name,
        onClick,
        spin
    } = props

    let className = 'icon fa '

    if(name.startsWith('fe')){
        className += 'fe '
        className += name
    }else{
        className += 'fa-'+name
    }

    if(spin){
        className += ' fa-spin'
    }

    if(props.className){
        className += ' '+props.className
    }

    return (
        <span 
            onClick={onClick ? onClick : _ => {}}
            className={className} 
        />
    )
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/icon/icon.jsx